import { type PayloadAction, isAction } from '@reduxjs/toolkit';

export const isPayloadAction = (action: unknown): action is PayloadAction =>
  isAction(action) && 'payload' in action;
